import React from 'react'
import { t, Trans } from '@lingui/macro'
import LocalisedImage from '../../LocalisedImage'
import verifiedImg from '../../../../../assets/verified.svg'
import './VerifiedBy.scss'

const VERIFIED_TEXT = t`Verified by Yoti`

const VerifiedBy = () => (
  <div className="verified-by">
    <LocalisedImage className="verified-by__img" src={verifiedImg} alt={VERIFIED_TEXT} />
    <span>
      <Trans id={VERIFIED_TEXT} />
    </span>
  </div>
)

export default VerifiedBy
